export default __webpack_public_path__ + "static/media/development_light.9aa34466.svg";